import DispensaryResults from "./DispensaryResults";

export default DispensaryResults;
